<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
  class="dark bg-gray-900 print:hidden flex flex-col min-h-screen"
  [mode]="isScreenSmall ? 'over' : 'side'"
  [name]="'mainNavigation'"
  [navigation]="navigation.default"
  [opened]="!isScreenSmall"
>
  <!-- Navigation header hook -->
  <ng-container fuseVerticalNavigationContentHeader>
    <div class="flex items-center w-full p-4 pl-6">
      <!-- Logo -->
      <div class="flex items-center justify-center">
        <img
          class=""
          src="assets\TrailFusion\Trail-Fusion_Logo-Design-revised-03.png"
        />
      </div>
      <!-- Components -->
      <div class="flex items-center ml-auto">
        <notifications></notifications>
        <user [showAvatar]="false"></user>
      </div>
    </div>
    <!-- User -->
    <div class="flex flex-col items-center w-full p-4">
      <div
        class="relative w-24 h-24 cursor-pointer overflow-hidden"
        (click)="navigateToAllMembership()"
      >
        <!-- Parent Image -->
        <img
          *ngIf="formattedParentImage"
          [src]="formattedParentImage"
          alt="User avatar"
          class="w-full h-full object-cover rounded-full"
          referrerpolicy="no-referrer"
        />

        <!-- Fallback User Avatar -->
        <img
          *ngIf="!formattedParentImage && user?.avatar"
          [src]="user.avatar"
          alt="User avatar"
          class="w-full h-full object-cover rounded-full"
          referrerpolicy="no-referrer"
        />

        <!-- Default Icon if no image -->
        <mat-icon
          *ngIf="!formattedParentImage && !user?.avatar"
          [svgIcon]="'heroicons_solid:user-circle'"
          class="w-full h-full text-gray-300"
        ></mat-icon>
      </div>

      <div class="flex items-center justify-center w-full mt-2">
        <div
          (click)="signOut()"
          class="text-center w-full ml-2 mt-0.5 whitespace-nowrap text-ellipsis overflow-hidden text-md leading-normal font-medium"
          style="text-align: left; cursor: pointer; color: grey"
        >
          Sign Out
        </div>
      </div>
      <div class="flex flex-col items-center justify-center w-full mt-3">
        <div
          class="w-full whitespace-nowrap text-ellipsis overflow-hidden text-center leading-normal font-medium"
        >
          {{ name || "--" }}
        </div>
      </div>
    </div>
  </ng-container>
  <div class="flex-1"></div>
  <!-- Footer (buttons at the bottom) -->
</fuse-vertical-navigation>

<!-- Rest of your HTML remains the same -->
<div class="flex flex-col flex-auto w-full min-w-0">
  <!-- Header -->
  <div
    class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden"
  >
    <!-- Navigation toggle button -->
    <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
      <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
    </button>
  </div>

  <!-- Content -->
  <div class="flex flex-col flex-auto">
    <router-outlet *ngIf="true"></router-outlet>
  </div>
</div>

<!-- Quick chat -->
<quick-chat #quickChat="quickChat"></quick-chat>
